import './mapToast.css';

// A short note at the bottom of a map ("Svedmyra avaktiverat") after an area is clicked on or off, shared by
// kartvy and listvy. One element per map, reused; it fades out after a moment.
const SHOW_MS = 1800;
const timers = new WeakMap();

export const showMapToast = (map, text) => {
    const container = map?.getContainer?.();
    if (!container || !text) return;
    let toast = container.querySelector(':scope > .map-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.className = 'map-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        container.appendChild(toast);
    }
    toast.textContent = text;
    // Restart the fade-in when a new note replaces a visible one.
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // eslint-disable-line no-void
    toast.classList.add('is-visible');
    window.clearTimeout(timers.get(toast));
    timers.set(toast, window.setTimeout(() => toast.classList.remove('is-visible'), SHOW_MS));
};

// "Svedmyra aktiverat" / "Svedmyra avaktiverat" (activated / deactivated).
// A shift-drag box over several areas (areaBoxSelect.js).
export const areasToggleToastText = (count, active, swedish) => {
    if (swedish) return `${count} områden ${active ? 'aktiverade' : 'avaktiverade'}`;
    return `${count} areas ${active ? 'activated' : 'deactivated'}`;
};

export const areaToggleToastText = (name, active, swedish) => {
    const label = String(name || '').trim();
    if (!label) return '';
    if (swedish) return `${label} ${active ? 'aktiverat' : 'avaktiverat'}`;
    return `${label} ${active ? 'activated' : 'deactivated'}`;
};
